var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popconfirm',_vm._g(_vm._b({attrs:{"title":_vm.title,"ok-text":_vm.okText,"cancel-text":_vm.cancelText,"ok-type":_vm.type}},'Popconfirm',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }